export const SOFT_BLACK_BORDER_RIGHT: string = 'soft-black-border-right';
export const SOFT_BLACK_BORDER_LEFT: string = 'soft-black-border-left';
export const SOFT_DASHED_BORDER_LEFT: string = 'soft-dashed-border-left';
export const SOFT_BORDER_LEFT: string = 'soft-border-left';
export const WHITE_LEFT_BORDER: string = 'white-left-border';
export const HEAVY_BORDER_RIGHT: string = 'heavy-border-right';
export const HEAVY_BORDER_LEFT: string = 'heavy-border-left';
export const FULL_WIDTH: string = 'full-width';
